import { isNil } from 'es-toolkit';

import type { LoginFormik } from '@savvy/deprecated-shared/x-pages/savvy-auth/x-login-types';
import { graphql as tadaGraphql } from '@savvy/deprecated-shared/gql-compat';
import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import { useRouter } from '@savvy/deprecated-shared/hooks/use-router';
import { useMutationWithErrorLogging } from '@savvy/deprecated-shared/hooks/useMutationWithErrorLogging';
import { getReturnUrl } from '@savvy/deprecated-shared/utils/routing';
import { AuthFactor, detectedTimeZonePayload } from '@savvy/deprecated-shared/utils/savvy-auth';
import { XLink } from '@savvy/deprecated-shared/x-components/x-link';
import { toast } from '@savvy/deprecated-shared/x-components/x-toast';
import { XTypography } from '@savvy/deprecated-shared/x-components/x-typography';

import { XOtpForm } from './x-otp-form';

const otpLoginFormMutation = tadaGraphql(/* GraphQL */ `
  mutation OtpLoginForm($input: ResendOtpInput!) {
    resendOtp(input: $input) {
      error
    }
  }
`);

export type OtpLoginFormProps = {
  readonly formik: LoginFormik;
};
export function XOtpLoginForm({ formik }: OtpLoginFormProps) {
  const [resendEmailOtp] = useMutationWithErrorLogging(otpLoginFormMutation, {
    variables: {
      input: {
        channel: 'email',
        currentPassword: formik.values.password,
        userEmail: formik.values.email,
      },
    },
  });
  async function handleSendEmailOtp() {
    const { data } = await resendEmailOtp();
    const error = data?.resendOtp?.error;
    if (isNil(error)) {
      toast.success('Email sent!');
    }
    return error;
  }
  const { login, user } = useAuth();
  const router = useRouter();

  return (
    <>
      <XOtpForm
        userEmail={formik.values.email}
        userInputPassword={formik.values.password}
        onSendEmail={handleSendEmailOtp}
        onSubmit={async (otp) => {
          const { loginErr } = await login({
            type: AuthFactor.Second,
            payload: {
              email: formik.values.email,
              password: formik.values.password,
              otp_attempt: otp,
              ...detectedTimeZonePayload(),
            },
          });
          if (loginErr) {
            console.warn(loginErr);
            formik.setStatus({ success: false });
            formik.setErrors({ submit: loginErr });
            formik.setSubmitting(false);
            return false;
          }
          router.push(getReturnUrl(router, user));
          return true;
        }}
      />
      <XTypography variant="body1" color="textSecondary" style={{ marginTop: 32 }}>
        Still having trouble?{' '}
        <XLink href="mailto:client-service@savvywealth.com" style={{ fontWeight: '600' }}>
          Contact us
        </XLink>
      </XTypography>
    </>
  );
}
